import { inject, Injectable } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { HttpClient, HttpContext } from "@angular/common/http";
import { BYPASS_BASE_URL } from "core";

// Ridefinito causa impossibilità di import
type TranslocoLoaderData = {
    scope: string;
};

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(lang: string, data?: TranslocoLoaderData) {
        let url = '/assets';
        if(data && data.scope) { // && data.scope == 'ipa') {
            let arraySplitLang = lang.split('/'); // parameter 'lang' is "scope/lang"
            let onlyLang = arraySplitLang[arraySplitLang.length-1]; // take only correct "lang" value
            url += `/${data.scope}/i18n/${onlyLang}.json`;
        } else {
            url += `/i18n/${lang}.json`;
        }
        return this.http.get<Translation>(url, { 
            context: new HttpContext().set(BYPASS_BASE_URL, true)
         });
    }
}
